import PropTypes from 'prop-types';
import { Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';

import { SORT_OPTIONS } from 'constants/common';
import { SORTABLE_TABLE_COLUMN_TYPES } from 'constants/components';

import SortableHeaderCell from './SortableHeaderCell';
import SortableTableCell from './SortableTableCell';

const styles = {
  tableContainer: {
    marginBottom: 14,
  },
  table: ({ spacing }) => ({
    borderSpacing: `0 ${spacing(2)}`,
    borderCollapse: 'separate',
  }),
};

const SortableTable = ({
  tableHeaders,
  rows,
  orderBy,
  order,
  onTableSort,
  onRowClick = null,
  onLabelClick = null,
  noDataContent = null,
}) => {
  const handleRowClick = (row) => {
    if (row.clickable && typeof onRowClick === 'function') {
      onRowClick(row);
    }
  };

  return (
    <TableContainer>
      <Table sx={styles.table}>
        <TableHead>
          <TableRow>
            {tableHeaders.map((headerData) => (
              <SortableHeaderCell
                key={headerData.dataKey}
                cellData={headerData}
                isSorted={orderBy === headerData.dataKey}
                order={order}
                onTableSort={onTableSort}
              />
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id} onClick={() => handleRowClick(row)} sx={row.clickable ? { cursor: 'pointer' } : {}}>
              {row.cells.map((cell) => (
                <SortableTableCell
                  key={cell.dataKey}
                  cellData={cell}
                  onLabelClick={typeof onLabelClick === 'function' ? () => onLabelClick(row) : null}
                />
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {!rows.length && noDataContent}
    </TableContainer>
  );
};

SortableTable.propTypes = {
  tableHeaders: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      dataKey: PropTypes.string.isRequired,
      align: PropTypes.string,
      sortable: PropTypes.bool,
      columnType: PropTypes.oneOf(Object.values(SORTABLE_TABLE_COLUMN_TYPES)).isRequired,
    }),
  ).isRequired,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      clickable: PropTypes.bool,
      cells: PropTypes.arrayOf(
        PropTypes.shape({
          dataKey: PropTypes.string.isRequired,
          columnType: PropTypes.oneOf(Object.values(SORTABLE_TABLE_COLUMN_TYPES)).isRequired,
          align: PropTypes.string,
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.array]),
          nameLength: PropTypes.number,
        }),
      ).isRequired,
    }),
  ).isRequired,
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.oneOf(Object.values(SORT_OPTIONS)).isRequired,
  onTableSort: PropTypes.func.isRequired,
  onRowClick: PropTypes.func,
  onLabelClick: PropTypes.func,
  noDataContent: PropTypes.node,
};
export default SortableTable;
